Ciao! Questo è un esempio dimostrativo della prova di selezione scolastica che affronterai il 16 dicembre 2022.

Questo esempio contiene _10 domande_ ed è pensato per essere risolto in _45 minuti_ (la prova ufficiale conterrà invece _20 domande_ da svolgere in _90 minuti_).

Se hai già affrontato la prova negli anni passati, o ne hai comunque letto i testi, noterai che lo stile di alcuni esercizi è cambiato, in particolare quelli a carattere algoritmico (terza parte). Inoltre, adesso il punteggio viene assegnato in base a nuove regole.

## Formato della prova

La prova consiste di quesiti a **scelta multipla** e quesiti a **domanda aperta numerica**, ed è divisa in tre parti:

- quesiti a **carattere logico-matematico**,
- quesiti di **programmazione** in pseudocodice, e
- quesiti a **carattere algoritmico**.

In ciascuna delle tre parti, i quesiti sono _indicativamente_ ordinati per difficoltà crescente. _Attenzione_: la difficoltà è spesso soggettiva! Se stai passando tanto tempo cercando di risolvere un quesito, considera di dare uno sguardo al successivo, o ai problemi di un’altra categoria!

### Punteggio

Tutti i quesiti a _scelta multipla_ presentano 5 opzioni, di cui **solo una** è corretta. Il punteggio assegnato per tali quesiti è:

- 5 punti per una risposta _esatta_;
- 1 punto per una risposta _in bianco_;
- 0 punti per una risposta _errata_.

I quesiti a _domanda aperta numerica_ richiedono come risposta un numero intero (eventualmente negativo). Il punteggio assegnato per tali quesiti è:

- 5 punti per una risposta _corretta_;
- 0 punti per una risposta _errata_ o _in bianco_.

### Quesiti di programmazione e pseudocodice

I quesiti di programmazione presentano semplici programmi scritti in _pseudocodice_. Qui sotto puoi trovare un riassunto della sintassi dello pseudocodice, oppure [scarica la guida completa](/Pseudocodice.pdf) in PDF.

![Riassunto guida pseudocodice](pseudocodice-cheatsheet.svg)
